import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core';
import { sendLogin } from '../../auth/Auth';
import BulkEditShopStatusCheckbox from '../atoms/BulkEditShopStatusCheckbox';
import GochiKidFlagEditShopCheckbox from '../atoms/GochiKidFlagEditShopCheckbox';

const propTypes = {
  classes: PropTypes.object.isRequired
};

const styles = {
  tableRow: {
    border: '1px solid #CCCCCC'
  },
  tableCell: {
    fontWeight: 'bold',
    fontSize: 12,
    borderBottom: '2px solid #CCCCCC',
    backgroundColor: '#ffffff'
    // display: 'flex'
  },
  tableHead: {
    border: '1px solid #CCCCCC'
  },
  tableSortLabel: {
    fontWeight: 'bold',
    fontSize: 12
  },
  floatRight: {
    // flexDirection: 'row-reverse'
  }
};

const enhance = compose(
  connect(state => ({
    shops: state.shops.shops ? state.shops.shops : []
  })),
  setPropTypes(propTypes),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    shops,
    onRequestSort,
    order,
    orderBy,
    showCheckboxEditStatus,
    bulkEditStatusCheckedAll,
    setBulkEditStatusCheckedAll,
    bulkEditStatusCheckedList,
    setBulkEditStatusCheckedList,
    isFukuoka,
    editGochiKidFlagCheckedAll,
    setEditGochiKidFlagCheckedAll,
    gochiKidFlagEditCheckedList,
    setGochiKidFlagEditCheckedList
  }) => {
    const shopIds = shops
      .filter(
        shop => shop.status === 'AVAILABLE' || shop.status === 'PRE_AVAILABLE'
      )
      .map(shop => shop.shopId);

    const checkAllEditStatus = () => {
      setBulkEditStatusCheckedList([...bulkEditStatusCheckedList, ...shopIds]);
    };

    const uncheckAllEditStatus = () => {
      setBulkEditStatusCheckedList(
        bulkEditStatusCheckedList.filter(id => !shopIds.includes(id))
      );
    };

    const checkAllEditGochiKidFlag = () => {
      setGochiKidFlagEditCheckedList(
        Array.from(new Set([...gochiKidFlagEditCheckedList, ...shopIds]))
      );
    };

    const uncheckAllEditGochiKidFlag = () => {
      setGochiKidFlagEditCheckedList(
        gochiKidFlagEditCheckedList.filter(id => !shopIds.includes(id))
      );
    };

    // Check all when change page
    // useEffect(() => {
    //   if (bulkEditStatusCheckedAll) {
    //     checkAllEditStatus();
    //   }
    // }, [shops]);

    return (
      <TableHead className={classes.tableHead}>
        <TableRow className={classes.tableRow}>
          <TableCell align="right" className={classes.tableCell}>
            <TableSortLabel
              direction={orderBy === 'shopId' ? order : 'asc'}
              className={[classes.tableSortLabel, classes.floatRight]}
              onClick={() => {
                onRequestSort('shopId');
              }}
            >
              {isFukuoka ? '教室ID' : '店舗ID'}
            </TableSortLabel>
          </TableCell>

          <TableCell className={classes.tableCell}>
            <TableSortLabel
              className={classes.tableSortLabel}
              direction={orderBy === 'shopName' ? order : 'asc'}
              onClick={() => {
                onRequestSort('shopName');
              }}
            >
              {isFukuoka ? '教室名' : '店舗名'}
            </TableSortLabel>
          </TableCell>

          <TableCell className={classes.tableCell}>
            <TableSortLabel
              className={[classes.tableSortLabel, classes.floatRight]}
              direction={orderBy === 'address' ? order : 'asc'}
              onClick={() => {
                onRequestSort('address');
              }}
            >
              住所
            </TableSortLabel>
          </TableCell>

          <TableCell className={classes.tableCell}>
            <TableSortLabel
              className={[classes.tableSortLabel, classes.floatRight]}
              direction={orderBy === 'phone' ? order : 'asc'}
              onClick={() => {
                onRequestSort('phone');
              }}
            >
              {isFukuoka ? '代表電話番号' : '電話番号'}
            </TableSortLabel>
          </TableCell>

          <TableCell className={classes.tableCell}>
            {isFukuoka ? 'ステータス' : '開店状況'}
          </TableCell>
          {showCheckboxEditStatus && !isFukuoka && (
            <>
              <TableCell className={classes.tableCell}>
                <BulkEditShopStatusCheckbox
                  disabled={shops.length === 0}
                  isCheckedAll={bulkEditStatusCheckedAll}
                  onCheckAction={() => {
                    setBulkEditStatusCheckedAll(true);
                    checkAllEditStatus();
                  }}
                  onUnCheckAction={() => {
                    setBulkEditStatusCheckedAll(false);
                    uncheckAllEditStatus();
                  }}
                />
              </TableCell>
              <TableCell className={classes.tableCell}>
                こどもごちめし参加
              </TableCell>
              <TableCell className={classes.tableCell}>
                <GochiKidFlagEditShopCheckbox
                  disabled={shops.length === 0}
                  isCheckedAll={editGochiKidFlagCheckedAll}
                  onCheckAction={() => {
                    setEditGochiKidFlagCheckedAll(true);
                    checkAllEditGochiKidFlag();
                  }}
                  onUnCheckAction={() => {
                    setEditGochiKidFlagCheckedAll(false);
                    uncheckAllEditGochiKidFlag();
                  }}
                />
              </TableCell>
            </>
          )}
          <TableCell className={classes.tableCell} />
          <TableCell className={classes.tableCell} />
        </TableRow>
      </TableHead>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
